module.exports = __webpack_public_path__ + "static/media/admin.bb18f2e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/img/admin.svg
// module id = 1023
// module chunks = 0